// extracted by mini-css-extract-plugin
export default {"layout":"dabfb6e26a _578b6d4dab a1163e8172","h_slide":"ce98a3aba1","category":"_01f2ae67ea bed7a400b0 _01e7efc88e"};